require("./storefront");

import Vue from "vue";
import store from "./store";

import {
    notify,
    trans,
    chunk
} from "./functions";

import VueToast from "vue-toast-notification";
import vClickOutside from "v-click-outside";


// --------------------------------------------------
// Global Components
// --------------------------------------------------

import VPagination from "./components/VPagination.vue";


// --------------------------------------------------
// Layout Components
// --------------------------------------------------

import NewsletterPopup from "./components/layout/NewsletterPopup";
import NewsletterSubscription from "./components/layout/NewsletterSubscription";
import CookieBar from "./components/layout/CookieBar";


// --------------------------------------------------
// Home Components
// --------------------------------------------------

import LandscapeProducts from "./components/LandscapeProducts.vue";
import DynamicTab from "./components/home/DynamicTab";
import HomeFeatures from "./components/home/HomeFeatures.vue";


// --------------------------------------------------
// Property Listing Components
// --------------------------------------------------

import ProductIndex from "./components/products/Index";

import ProductCardGridView from "./components/products/index/ProductCardGridView.vue";

import ProductCardListView from "./components/products/index/ProductCardListView.vue";

import ProductCardVertical from "./components/ProductCardVertical.vue";

import ProductShow from "./components/products/Show";


// --------------------------------------------------
// Vue Global Helpers
// --------------------------------------------------

Vue.prototype.route = route;

Vue.prototype.$notify = notify;

Vue.prototype.$trans = trans;

Vue.prototype.$chunk = chunk;


// --------------------------------------------------
// Vue Plugins
// --------------------------------------------------

Vue.use(VueToast);

Vue.use(vClickOutside);


// --------------------------------------------------
// Common Components
// --------------------------------------------------

Vue.component(
    "v-pagination",
    VPagination
);


// --------------------------------------------------
// Layout Components
// --------------------------------------------------

Vue.component(
    "newsletter-popup",
    NewsletterPopup
);

Vue.component(
    "newsletter-subscription",
    NewsletterSubscription
);

Vue.component(
    "cookie-bar",
    CookieBar
);


// --------------------------------------------------
// Existing Common Components
// --------------------------------------------------

Vue.component(
    "landscape-products",
    LandscapeProducts
);

Vue.component(
    "dynamic-tab",
    DynamicTab
);

Vue.component(
    "home-features",
    HomeFeatures
);


// --------------------------------------------------
// Property Listing
// --------------------------------------------------

Vue.component(
    "product-index",
    ProductIndex
);

Vue.component(
    "product-card-grid-view",
    ProductCardGridView
);

Vue.component(
    "product-card-list-view",
    ProductCardListView
);

Vue.component(
    "product-card-vertical",
    ProductCardVertical
);

Vue.component(
    "product-show",
    ProductShow
);


// --------------------------------------------------
// Main Vue Application
// --------------------------------------------------

new Vue({

    el: "#app",

    computed: {

        /*
         * Cart is kept temporarily for legacy compatibility.
         * It is no longer displayed anywhere in the
         * property website frontend.
         */
        cart() {
            return store.state.cart;
        },

        /*
         * Wishlist count kept temporarily for compatibility.
         * Wishlist UI is no longer displayed.
         */
        wishlistCount() {
            return store.wishlistCount();
        }

    }

});


// --------------------------------------------------
// AJAX Configuration
// --------------------------------------------------

$.ajaxSetup({

    headers: {

        "X-CSRF-TOKEN": FleetCart.csrfToken

    }

});